import type { MachineLogType } from '../../types'
import { TYPE_COLORS, TYPE_LABELS, formatTime } from './shared'
import type { TagReading } from './shared'

export function TypeBadge({ type }: { type: MachineLogType }) {
  return (
    <span className={`inline-block px-1.5 py-px rounded font-mono text-[11px] font-medium tracking-wide ${TYPE_COLORS[type]}`}>
      {TYPE_LABELS[type]}
    </span>
  )
}

export function TabButton({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick}
      className={`pb-3 text-sm font-medium transition border-b-2 ${
        active ? 'border-accent text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-800'
      }`}>
      {children}
    </button>
  )
}

// 탭 안의 보조 탭 (마스터데이터 설정·실시간·조회)
export function SegmentButton({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick}
      className={`px-3 py-1.5 rounded-md text-xs font-medium transition ${
        active ? 'bg-surface text-gray-900 shadow-sm ring-1 ring-gray-200' : 'text-gray-500 hover:text-gray-800'
      }`}>
      {children}
    </button>
  )
}

export function Chip({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-xs font-medium transition ${
        active ? 'bg-gray-800 text-gray-50' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
      }`}>
      {children}
    </button>
  )
}

export function MessageCard({ tone = 'muted', children }: { tone?: 'muted' | 'error'; children: React.ReactNode }) {
  return (
    <div className={`bg-surface rounded-xl border border-gray-100 shadow-sm p-8 text-center text-sm ${tone === 'error' ? 'text-red-600' : 'text-gray-500'}`}>
      {children}
    </div>
  )
}

// 태그 값 셀 — 스트림으로 갱신될 때마다(rev) 하이라이트를 다시 재생한다. 스냅샷 값(rev 0)은 하이라이트하지 않는다
export function ReadingValueCell({ reading, className = '' }: { reading: TagReading | null; className?: string }) {
  return (
    <td key={reading?.rev ?? 0}
      className={`px-4 py-2.5 text-gray-700 ${reading && reading.rev > 0 ? 'animate-[value-flash_1.2s_ease-out]' : ''} ${className}`}>
      {reading ? reading.value : <span className="text-gray-300">-</span>}
    </td>
  )
}

export function ReadingTimeCell({ reading }: { reading: TagReading | null }) {
  return (
    <td className="px-4 py-2.5 text-gray-500 text-xs font-mono whitespace-nowrap">
      {reading ? formatTime(reading.time) : '-'}
    </td>
  )
}
